/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 22, 2026 by hoarfroster
 *
 */

/**
 * localStorage wrappers that tolerate environments without storage
 * (SSR, unit tests) so importing modules never crashes at load time.
 */

/** Returns a usable localStorage or null when absent/broken (SSR, tests). */
function safeLocalStorage(): Storage | null {
    try {
        if (typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function') return localStorage;
    } catch {
        // Storage access denied (e.g. blocked cookies) — degrade to no-op.
    }
    return null;
}

export function getStorageItem(key: string): string | null {
    return safeLocalStorage()?.getItem(key) ?? null;
}

export function setStorageItem(key: string, value: string): void {
    safeLocalStorage()?.setItem(key, value);
}

export function clearStorage(): void {
    safeLocalStorage()?.clear();
}

export function setCookie(name: string, value: string, options: { expires?: Date; path?: string } = {}) {
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (options.expires) {
        cookieString += `; expires=${options.expires.toUTCString()}`;
    }

    if (options.path) {
        cookieString += `; path=${options.path}`;
    }

    document.cookie = cookieString;
}

export function getCookie(name: string) {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === decodeURIComponent(name)) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}
